import React, { useEffect, useState } from 'react';
import axios from '../helpers/axios';
import { useAuth } from 'react-oidc-context';
import { Card, Spin, message } from 'antd';

import { UserOutlined, CrownOutlined } from '@ant-design/icons';

function AccountIdentifier(props) {
  const { user } = useAuth();
  const keycloak_id = user?.profile?.sub; // Assuming `sub` contains the Keycloak ID.
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(true);

  const { toggleClose } = props;

  useEffect(() => {
    const fetchRoles = async () => {
      try {
        const response = await axios.get('/api/user/get/roles/', {
          params: { keycloak_id },
        });
        setRoles(response.data || []);
      } catch (error) {
        message.error('Failed to fetch roles. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    if (keycloak_id) {
      fetchRoles();
    }
  }, [keycloak_id]);

  const handleAccountSelection = async (roleId) => {
    try {
      const response = await axios.get(`/api/user/get/details/role/`, {
        params: { keycloak_id, role_id: roleId },
      });
      const accountDetails = response.data;

      setTimeout(() => {
        toggleClose();
      }, 1200);
    } catch (error) {
      message.error('Failed to fetch account details. Please try again later.');
      setTimeout(() => {
        toggleClose();
      }, 1200);
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-[400px]">
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center h-[400px] text-white">
      <h1 className="text-3xl font-bold mb-8">Select Your Role</h1>
      <div className="flex gap-6">
        {roles.map((role) => (
          <Card
            key={role.id}
            className="hover:scale-105 transform transition-transform duration-300"
            style={{
              width: 200,
              background: 'transparent',
              border: '2px solid #fff',
              textAlign: 'center',
              cursor: 'pointer',
            }}
            onClick={() => handleAccountSelection(role.id)}
          >
            <div
              className={`w-16 h-16 mx-auto rounded-full flex items-center justify-center bg-${
                role.description && role.description.includes('admin') ? 'yellow' : 'blue'
              }-400`}
            >
              {role.description && role.description.includes('admin') ? (
                <CrownOutlined size={20} />
              ) : (
                <UserOutlined size={20} />
              )}
            </div>
            <h2 className="mt-4 text-xl font-semibold">{role.description}</h2>
          </Card>
        ))}
      </div>
    </div>
  );
}

export default AccountIdentifier;
